import * as styles from './beta-tag.css'

export const BetaTag: React.FC = () => {
  return (
    <span
      className={styles.betaTag}
      style={{ paddingTop: '2px', paddingBottom: '2px', paddingLeft: '8px', paddingRight: '8px' }}
    >
      Beta
    </span>
  )
}
